import React, { useState, useEffect } from 'react';
import Marquee from "react-fast-marquee";
import axios from 'axios';
import { useCookies } from 'react-cookie';

const SponsorsMarqueeV2 = ({ award_id }) => {
  const [cookies] = useCookies(['currentUser', 'isLoggedIn', 'userRole', 'token']);
  const currentUser = cookies.currentUser;
  const token = cookies.token;

  const [sponsors, setSponsors] = useState([]);
  const [sponsorsLoading, setSponsorsLoading] = useState(true);

  const getSponsors = async () => {
    // return await axios.get(process.env.REACT_APP_API_ENDPOINT + 'event/' + award_id + '/sponsor');
    return await axios.get(process.env.REACT_APP_API_ENDPOINT + 'sponsorship/agreement?award_id='+award_id);
  }

  useEffect(() => {
    getSponsors().then(response => {
      const selectedSponsors = response.data.data;
      if (selectedSponsors) {
        setSponsors(selectedSponsors);
        setSponsorsLoading(false);
        console.log(selectedSponsors);
      } else {
        setSponsorsLoading(false);
      }
    }).catch(() => {
      console.log("Error getting sponsors")
      setSponsorsLoading(false);
    });
    
  }, []);

  return (
    <div className="marquee-container">
      {sponsorsLoading ?
        null
        :
        <Marquee autoFill={true}>
          {sponsors.map((sponsor, index) => {
            let sponsor_logo = sponsor.image_url;
            if(award_id && award_id == 104) {
              if (sponsor.company_name == "Amárach Research" || sponsor.company_name == "Amarach Research") {
                sponsor_logo = "wipa/amarach.png";
              } else if (sponsor.company_name == "The Irish Times") {
                sponsor_logo = "the-irish-times.jpeg";
              } else if (sponsor.company_name == "Making Shift Happen") {
                sponsor_logo = "wipa/mhs.png";
              } else if (sponsor.company_name == "Cronin Group") {
                sponsor_logo = "wipa/cronin.png";
              } else if (sponsor.company_name == "Kuehne+Nagel") {
                sponsor_logo = "wipa/kuehne.png";
              } else if (sponsor.company_name == "Cognizant") {
                sponsor_logo = "wipa/cognizant.png";
              } else if (sponsor.company_name == "Cencora Pharmalex") {
                sponsor_logo = "wipa/cencora.png";
              }
            } else {
              if (sponsor.company_name == "Amárach Research" || sponsor.company_name == "Amarach Research") {
                sponsor_logo = "amarach-research.png";
              } else if (sponsor.company_name == "The Irish Times") {
                sponsor_logo = "the-irish-times.jpeg";
              } else if (sponsor.company_name == "Panda") {
                  sponsor_logo = "panda.png";
              } else if (sponsor.company_name == "HSI Skillko") {
                  sponsor_logo = "hsi-skillko.png";
              } else if (sponsor.company_name == "Bretland") {
                  sponsor_logo = "bretland.png";
              } else if (sponsor.company_name == "Axon Outsourcing Limited") {
                sponsor_logo = "axon.png";
              } else if (sponsor.company_name == "Sage") {
                sponsor_logo = "sage.png";
              } else if (sponsor.company_name == "Chartered Accountants Ireland") {
                sponsor_logo = "chartered.png";
              } else if (sponsor.company_name == "Financefair") {
                sponsor_logo = "financefair.png";
              } else if (sponsor.company_name == "ETL Global Ireland") {
                sponsor_logo = "etl.png";
              } else if (sponsor.company_name == "Saffery") {
                sponsor_logo = "saffery.png";
              } else if (sponsor.company_name == "NoFrixion") {
                sponsor_logo = "nofrixion.png";
              } else if (sponsor.company_name == "Iris Software Group") {
                sponsor_logo = "iris.png";
              } else if (sponsor.company_name == "Circit") {
                sponsor_logo = "circit.png";
              } else if (sponsor.company_name == "Search4Less") {
                sponsor_logo = "search4less.png";
              } else if (sponsor.company_name == "Mercia Ireland") {
                sponsor_logo = "mercia.png";
              } else if (sponsor.company_name == "Dornan Engineering Limited, A Turner Company") {
                sponsor_logo = "dornan.png";
              } else if (sponsor.company_name == "Mercury Engineering") {
                sponsor_logo = "mercury-engineering.png";
              }
            }
            
            return (
              <div className="marquee-item" key={index}>
                {sponsor.website ? 
                  <a href={sponsor.website ? sponsor.website : "" } target="_blank" rel="noopener noreferrer">
                    <img src={`${process.env.REACT_APP_URL}/storage/agreements/thumbnails/${sponsor_logo}`} alt={sponsor.company_name} style={sponsor.company_name === "Pennypop" || sponsor.company_name === "Bunzl Ireland" || sponsor.company_name === "RFC Security Group" ? { height: '4.5vw' } : sponsor.company_name == "Cronin Group" || sponsor.company_name == "Walls Construction" ? { height: '2.5vw' } : {}} />
                  </a>
                  :
                  <img src={`${process.env.REACT_APP_URL}/storage/agreements/thumbnails/${sponsor_logo}`} alt={sponsor.company_name} style={sponsor.company_name === "Pennypop" || sponsor.company_name === "Bunzl Ireland" || sponsor.company_name === "RFC Security Group" ? { height: '4.5vw' } : sponsor.company_name == "Cronin Group" || sponsor.company_name == "Walls Construction" ? { height: '2.5vw' } : {}} />
                }
              </div>
            );
          })}
        </Marquee>
      }
    </div>
  );
};

export default SponsorsMarqueeV2;
